import React, { useContext, useEffect, useState } from "react";
import Page from "../../general_components/Page";
import StackCustom from "../../general_components/StackCustom";
import { CircularProgress, Container, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { PRIMARY_COLOR_DarkNavyBlue } from "../../constants/Colors";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { TeamContext } from "../../contexts/TeamsContext";
import TeamCard from "./components/TeamCard";
import TeamModal from "./components/TeamModal";
import DetailModal from "./components/DetailModal";


export default function Teams() {

  const { allTeam, handleAddTeam, fetchTeams,handleEmpty,setEditMode } = useContext(TeamContext);
  const [open, setOpen] = useState(false);
  const [openDetail, setOpenDetail] = React.useState(false);
  const [detailItem, setDetailItem] = React.useState(null);

  const handleOpen = () => {
    setEditMode(false)
    setOpen(true);
  };

  const handleClose = () => {
    handleEmpty();
    setOpen(false);
  };

  useEffect(() => {
    fetchTeams()
  },[])

  return (
    <>
      <Page title="ARCSMEN Design Lab | Team">
        <Container>
          <StackCustom
            text={"Team"}
            children={
              <Tooltip title="Add Team">
                <IconButton
                  style={{
                    backgroundColor: PRIMARY_COLOR_DarkNavyBlue,
                    color: "#fff",
                    marginLeft: 6,
                  }}
                  variant={"contained"}
                  onClick={handleOpen}
                >
                  <AddRoundedIcon size={18} />
                </IconButton>
              </Tooltip>
            }
          />
          <div
            style={{
              paddingRight: "2vw",
              display: "flex",
              gap: "20px",
              flexWrap: "wrap",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            {Array.isArray(allTeam) && allTeam.length > 0 ? (
              allTeam.map((item, index) => (
                <TeamCard
                  key={`TeamCard${index}`}
                  item={item}
                  setOpenDetail={setOpenDetail}
                  setDetailItem={setDetailItem}
                />
              ))
            ) : (
              <div>
                {allTeam && allTeam.length === 0 ? (
                  <Typography variant={"h6"}>No Team Found</Typography>
                ) : (
                  <CircularProgress color="inherit" />
                )}
              </div>
            )}
          </div>
        </Container>
      </Page>
      {openDetail ? (
        <DetailModal
          item={detailItem}
          open1={openDetail}
          handleClose1={() => setOpenDetail(false)}
        />
      ) : null}
      <TeamModal
        title="Add Team"
        text="Add Team"
        open={open}
        handleClose={handleClose}
        handlerFunction={handleAddTeam}
      />
    </>
  );
}
